import React from 'react'

const GameSetup = () => {
  return (
    <div>
      Game Setup
    </div>
  )
}

export default GameSetup
